import React from 'react'
import {images} from '../../constants';

import { FaLinkedin } from 'react-icons/fa';
import { FaFacebookF } from 'react-icons/fa';
import {FaMapMarkerAlt} from 'react-icons/fa'
import {ImWhatsapp} from 'react-icons/im'
import {AiFillInstagram} from 'react-icons/ai'
import {BsYoutube} from 'react-icons/bs'
import {BiTime} from 'react-icons/bi'


import './Foot.scss'

const Foot = () => {
  return (
   <footer>
    <div className="container footer__container">
        <article>
            <div className='logo'>
            <img src={images.logo} alt="logo" />
            </div>
            <h2>Dr Eman's <span>Dental Care </span> </h2>
           <div className='time'>
          
            <p>
            Dr. Eman's Dental Clinic is located in Bahria Town, Islamabad, Rawalpindi, and is open every day of the year. A team of G.P. dentists and specialists, led by Dr. Eman Afroze and team, are on hand throughout the week to make sure your gums and teeth are healthy. 
We offer comprehensive dental procedures,  including: 
Dental implants Wisdom teeth extraction, root canal therapy, orthodontics (braces, invisalign), paediatric dentistry, dental crowns, oral hygiene, and teeth whitening. 
Treatments for periodontal diseases and many more! 
Come see us to have all your dental issues fixed!
            </p>
           </div>
            
          

            <div className="footer__socials">
                <a href="https://www.facebook.com/profile.php?id=100086334284466" 
                target='_blank' rel='noreferrer noopener' > <FaFacebookF/> </a>

                <a href="https://www.instagram.com/dremandental/" 
                target='_blank' rel='noreferrer noopener' > <AiFillInstagram/> </a>

                <a href="https://www.google.com/maps/dir/Bahria+Town+Safari+Villas+3,+Rawalpindi,+Islamabad,+Punjab,+Pakistan/dr+emans+dental+care/@33.5545291,73.1256169,18z/data=!3m1!4b1!4m13!4m12!1m5!1m1!1s0x38dfed03abc0299b:0x3f179dd72603e8df!2m2!1d73.1253715!2d33.5551746!1m5!1m1!1s0x38dfed4cd72457c3:0x2a3b66bfb5134a9f!2m2!1d73.1285317!2d33.5538947" 
                target='_blank' rel='noreferrer noopener' > <FaMapMarkerAlt/> </a>

                <a href="https://www.linkedin.com/in/dr-eman-afroze-952842148/" 
                target='_blank' rel='noreferrer noopener' > <FaLinkedin/> </a>    

                <a href="https://api.whatsapp.com/send?phone=+923315991135" 
                target='_blank' rel='noreferrer noopener' > <ImWhatsapp/> </a>

                <a href="https://www.youtube.com/channel/UCGY_Z3GqLtLqZFcXi-Ffn0g" 
                target='_blank' rel='noreferrer noopener' > <BsYoutube/> </a>
            </div>

        </article>

        <article>
            <h2>My Partners</h2>
            
            <div className='app__foot-item'>

            <div className='app__flex'>
            <a href="https://www.marham.pk/online-consultation/dentist/islamabad/dr-eman-afroze-21727" target='_blank' rel='noreferrer noopener'>
            <img src={images.marham} alt="marham" />
            </a>
            </div>
           
            
            <div className='app__flex'>
            <a href="https://instacare.pk/doctors/rawalpindi/dentist/dr-eman-afroze" target='_blank' rel='noreferrer noopener'>
            <img  src={images.instacare} alt="instacare" />
            </a>
            </div>
            
           <div className='app__flex'>
           <a href="https://www.shifaam.com/doctors/rawalpindi/dentist/eman-afroze-12476" target='_blank' rel='noreferrer noopener'>
            <img  src={images.shifaam} alt="shifaam" />
           
                </a> 
           </div>
           
               
            
            <div className='app__flex'>
            <a href="https://healthwire.pk/hospitals/rawalpindi/dr-eman-s-dental-care/dentist" target='_blank' rel='noreferrer noopener'>
            <img  src={images.healthwire} alt="healthwire" />
           
                </a>  
            </div>
           
                
           <div className='app__flex'>
           <a href="https://oladoc.com/pakistan/rawalpindi/dr/dentist/eman-afroze/521430" target='_blank' rel='noreferrer noopener'>
            <img  src={images.oladoc} alt="" />
          
            </a>
           </div>
            
            </div>
            
        </article>

        <article>
            <h2> Clinic Timings </h2>
            <div className='time'>
            <p><BiTime/> Monday-Friday : 2pm - 8pm</p>
            <p><BiTime/> Saturday-Sunday : 3pm - 8pm</p>
            </div>
           
        </article>

        <article>
            <h2> Locate us at </h2>
            <div className='time'>
            <p><FaMapMarkerAlt/> Commercial Market Phase V, Bahria Town Rawalpindi, Pakistan</p>
            
            </div>
          
        </article>

    </div>

    <div className='footer__copyright'>
        <small>Dr Eman's Dental Care &copy; All Rights Reserved</small>
    </div>

   </footer>
  )
}

export default Foot